export const RepoType = Object.freeze({
    SQLLITE: 'sqllite',
    CONTENT: 'content',
    POSTGRESS: 'postgress',
    MSSQL: 'mssql',
    CLOUD: 'online',
    GLOBAL: 'global',
    MASTER_AGENT: 'master_agent',
    EMAIL: 'email',
    INTERNET: 'internet',
    VIRTUAL: 'virtual',
    EXTRACTED_DB: 'extracted_db',
    AUTO_DB: 'auto_db',
    TABULAR: 'tabular',
});
